import folderImg from './assets/folder.png';
import pepleImg from './assets/people.png';
import pepleWithHouseImg from './assets/people_with_house.png';

export const CONTENT = [
  {
    title: 'Собственник не может приехать на сделку',
    text: 'Онлайн-договор подписывается в приложении Госключ из любой точки',
    imgSrc: pepleImg,
    imgWidth: '106',
    imgHeight: '100',
  },
  {
    title: 'Вы не можете приехать на сделку',
    text: 'Оформите всё даже стоя в пробках — не нужно ничего отменять или переносить',
    imgSrc: pepleWithHouseImg,
    imgWidth: '151',
    imgHeight: '100',
  },
  {
    title: 'Нет бумажного договора под рукой',
    text: 'Неожиданный выход на сделку — онлайн-договор выручит',
    imgSrc: folderImg,
    imgWidth: '96',
    imgHeight: '100',
  },
];
